import { Configuration, RedirectRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: 'f2d6abe6-8157-4ce1-b764-a52741b3d10b',
    authority: 'https://login.microsoftonline.com/f1c11af8-8b01-4991-87db-657cba0c23ad',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  }
};

export const loginRequest: RedirectRequest = {
  scopes: [
    'api://f2d6abe6-8157-4ce1-b764-a52741b3d10b/access_as_user',
    'openid',
    'profile',
    'email'
  ],
  prompt: 'select_account', // Allow account selection
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
